function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2 0h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4l-4 4V2C0 .9.9 0 2 0zm2 14h14V2H2v14l2-2z",
  fill: "#000",
  fillOpacity: 0.54
});

var SvgIconChatBubbleOutline = function SvgIconChatBubbleOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none"
  }, props), _ref);
};

export default __webpack_public_path__ + "assets/icon-chat_bubble_outline.d55ea048.svg";
export { SvgIconChatBubbleOutline as ReactComponent };